jQuery(document).ready(function($){
//wrap two section 
  jQuery(".cart-item-sec, .cart__footer-wrapper").wrapAll("<section class='wrap-cart-item-footer page-width'></section>");
  
  const urlParams = new URLSearchParams(window.location.search);
  const searchTerm = urlParams.get('q');
  jQuery('.custom-search-form input[type=search]').val(searchTerm);
  $('.carousel').slick({
  slidesToShow: 2,
  dots:false,
    loop:false,
   arrows: true ,
   responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: true,
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ] 
  });

  $(".dropdown-toggle").click(function() {
  $(this).toggleClass("on");
  $(".dropdown-menu").slideToggle();
});
});

function updateSearchAction() {
  var select = document.getElementById('collection-select');
  var form = document.querySelector('.custom-search-form');
  var selected = select.value;

  // If a collection is selected, change form action
  if (selected) {
    form.action = '/collections/' + selected;
  } else {
    form.action = '/search';
  }

  return true; // proceed with form submission
}

$('.grid-view').on('click', function() {
  $('.listing-grid').removeClass('grid-view-container');
});
$('.default-view').on('click', function() {
  $('.listing-grid').addClass('grid-view-container');
});
